import { ActionFooterWithMenu } from '../shared/ActionFooterWithMenu';

interface RefinementApprovalFooterProps {
    canRequestRevision: boolean;
    /** False while a revision request (or the approve action itself) is in flight. */
    canApprove: boolean;
    isSubmitting: boolean;
    onApprove: () => void;
    onRequestRevision: () => void;
}

export function RefinementApprovalFooter({
    canRequestRevision,
    canApprove,
    isSubmitting,
    onApprove,
    onRequestRevision
}: RefinementApprovalFooterProps) {
    return (
        <ActionFooterWithMenu
            primaryLabel="Approve design →"
            canSubmit={canApprove}
            isSubmitting={isSubmitting}
            onSubmit={onApprove}
            menuActions={[
                {
                    label: 'Request a revision',
                    onClick: onRequestRevision,
                    tone: 'amber',
                    hidden: !canRequestRevision
                }
            ]}
        />
    );
}
